import { Spinner, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { ModalProps } from '../../types';

import styles from './index.module.scss';

const LoadingModal = ({ isOpen }: ModalProps) => {
  const { t } = useTranslation('Disconnect');
  return (
    <Surface className={styles.loadingModal} onClick={() => isOpen}>
      <div className={styles.loadingModalContent}>
        <Spinner size="medium" />
        <Txt>{t('retentionOffers.loadingModal.description')}</Txt>
      </div>
    </Surface>
  );
};

export default LoadingModal;
